// Slovenian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `odprto do ${date}` : ''),
    },
    interview: {
      title: 'Odgovor na video razgovor',
      submit: 'Pošlji odgovore in zaključi razgovor',
      continueLater: 'Nadaljuj kasneje',
      startInterview: 'Začni razgovor',
      duplicateError: 'V tem razgovoru ste že sodelovali. Prejeli ste e-pošto z naslova invitations@recright.com, ki vsebuje povezavo, prek katere lahko nadaljujete razgovor.',
      confirmSubmitHeader: 'Niste odgovorili na vsa vprašanja v razgovoru',
      confirmSubmitContent: 'Ali ste prepričani, da želite zaključi ta razgovor?',
      confirmSubmitContentWarning: 'Po tem ne morete dopolniti svojih odgovorov.',
      submitInterviewHeader: 'Pošljite odgovore na vprašalnik',
      submitInterviewContent: 'Ali ste prepričani, da želite poslati vprašalnik?',
      confirmSubmitButton: 'Pošlji odgovore in zaključi razgovor',
      preview: 'Video vprašanja si lahko vnaprej ogledate tukaj.',
      requiredQuestionsNotAnswered: 'Prosimo, odgovorite na vsa obvezna vprašanja pred oddajo.',

      withdrawLink: 'Vas to delovno mesto ne zanima več? Kliknite tukaj za odstop od postopka.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Ime',
      city: 'Kraj bivanja',
      email: 'E-naslov',
      phone: 'Telefonska številka',
      link: 'Povezava',
      legendBasicInfo: 'Osnovne informacije',
      placeholderName: 'Vnesite svoje ime',
      placeholderEmail: 'Vnesite svoj e-poštni naslov',
      placeholderPhone: 'Vnesite svoj telefon',
      placeholderCity: 'Vnesite svoje trenutno mesto',
      placeholderLink: 'Dodajte povezavo, na primer svoj LinkedIn profil.',
      legendAttachments: 'Priloge',
      legendAdditionalFields: 'Dodatne informacije',
      required: 'Predmeti, označeni z * zvezdico so obvezni.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Avdio',
        video: 'Video',
        yes: 'Da',
        no: 'Ne',
        supported: 'Podprto',
        quality: 'Kakovost',
        header: 'Test omrežne povezave in naprave',
        description: 'Zdaj bomo izvedli test, da preverimo, ali vaša omrežna povezava in strojna oprema, ki sta potrebni za razgovor (kamera in telefon), pravilno delujeta. Ko boste pozvani, testu omogočite uporabo vaše kamere in mikrofona ter preverite, da vaša kamera ni pokrita. Test bo trajal približno 30 sekund. Priporočamo, da med testiranjem strojne opreme govorite.',
        inProgress: 'Testiranje poteka ...',
        networkTestResults: 'Rezultati testa omrežja',
        qualityTestResults: 'Rezultati testa kakovosti',
        testPassedQuality: 'Test kakovosti je uspel',
        testFailedQuality: 'Test kvalitete ni uspel',
        testPassedNetwork: 'Test omrežja je uspel',
        testFailedNetwork: 'Test omrežja ni uspel',
        startTest: 'Začetek testa',
        startInterview: 'Začetek razgovora',
        testAgain: 'Ponovitev testa',
        confirmWarning: 'Ko se video razgovor začne, boste samodejno preusmerjeni na ogled prvega vprašanja. Po ogledu vprašanja boste preusmerjeni na pripravo.',
        confirmTitle: 'Razgovor se bo kmalu pričel.',
        confirmText: 'Pred vsakim vprašanjem boste dobili trenutek, da se pripravite na odgovor. Po pripravi boste imeli na voljo vnaprej določeno količino časa, da odgovorite na vprašanje. Upoštevajte, da lahko odgovor predložite takoj, ko boste pripravljeni, tudi če čas še ni potekel.',
        confirmText2: 'Ko oddate odgovor, se pomaknete na naslednje vprašanje, dokler vprašanj ne zmanjka.',
        confirmText3:
          'Upoštevajte, da ko posnamete odgovor na vprašanje, boste imeli na voljo 30 sekund, da se odločite, ali ga želite posneti znova, če je ponovno snemanje odgovora dovoljeno. Če v 30 sekundah ne začnete ponovnega snemanja, bo vaš trenutni odgovor samodejno poslan, nato pa boste preusmerjeni na naslednje vprašanje.',
        goodLuck: 'Samo globoko vdihnite in vse bo v redu. Vso srečo!',
        qualityRating: {
          excellent: 'Odlično',
          good: 'Dobro',
          fair: 'Povprečno',
          poor: 'Pomanjkljivo',
          bad: 'Slabo',
        },
      },
      questionAnswerView: {
        title: title => `Odgovor na razgovor ${title}`,
        question: 'Vprašanje',
        submitAndNext: 'Oddaj in nadaljuj',
        submitSuccess: 'Video uspešno oddan!',
        skipText: 'Začetek snemanja',
        stop: 'Ustavi',
        submitAndFinish: 'Oddaj in zaključi intervju',
        retake: 'Ponovno posnemi odgovor',
        take: 'Posnemi odgovor',
        takesLeft: 'Število preostalih posnetkov',
        skipTextQuestion: 'Pripravljen/a? Premakni se naprej',
        retakeConfirmTitle: 'Ali ste prepričani, da želite znova posneti odgovor na to vprašanje?',
        retakeConfirmSubmit: 'Da, začni s ponovnim snemanjem odgovora.',
        submitInfoForward: 'Do samodejnega pošiljanja odgovora in preusmeritve na novo vprašanje imate na voljo še',
        submitInfoForward2: 'sekund',
        nonAnswerableText: 'Na to sporočilo vam ni potrebno odgovoriti. Po tem sporočilu boste nadaljevali neposredno na naslednje vprašanje.',
        nonAnswerableVideo: 'Na ta videoposnetek vam ni potrebno odgovoriti. Po tem videoposnetku boste nadaljevali neposredno na naslednje vprašanje.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Za odgovor na vprašanje imate na voljo ${answerMinutes} min in ${answerSeconds} s.`,
      },
      publisher: {
        toNextQuestion: timer => `Prehod na naslednje vprašanje čez ${timer}`,
        recordingStarts: timer => `Snemanje se začne čez ${timer}`,
      },
      errors: {
        tooManyConnections: 'Povezava se je zaprla, ker je že odprta v drugem zavihku ali oknu.',
        unsupportedBrowser: 'Na žalost operacija v vašem brskalniku ni podprta. Uporabite drug brskalnik.',
        networkError: 'Ni internetne povezave.',
        reconnecting: 'Povezava je bila prekinjena. Poskus ponovne povezave.',
        generalError: 'Nekaj je šlo narobe. Osvežite stran in poskusite znova.',
        allowMediaDevicesError: 'Ta operacija se ni uspela povezati z medijskimi napravami (kamera ali mikrofon). Prepričajte se, da ste brskalniku omogočili uporabo vaše kamere in mikrofona.',
        noAvailableDevicesError: 'Kamere ali mikrofona ni bilo mogoče najti.',
        initPublisherError: 'Postopek ni uspel zaradi napake. Prepričajte se, da ste brskalniku dovolili uporabo kamere in mikrofona ter da ju ne uporablja druga aplikacija. Nato poskusite znova.',
      },
      browserInfo: {
        browserSupportTitle: 'Podpora brskalnika',
        supportedBrowsers: 'Ta test in razgovor podpirata najnovejše različice brsklanikov Chrome, Firefox, Safari in Edge.',
        mobileSupported: 'Podprti brskalniki v mobilni napravi',
        android: 'Android: Google Chrome (zadnja različica), Firefox (zadnja različica)',
        iOS: 'iOS: Safari (zadnja različica)',
        latestVersion: 'Prepričajte se, da uporabljate najnovejšo različico brskalnika. Tako boste zagotovili nemoteno delovanje.',
        freezeInstruction: 'Če se snemanje videa ne začne ali če snemalni zaslon ostane črn, prosimo, osvežite stran.',
        unsupportedOnIos: 'Videti je, da v sistemu iOS uporabljate nepodprto različico brskalnika. Uporabite brskalnik Safari.',
        ieUnsupported: 'Videti je, da uporabljate brskalnik Internet Explorer. Na žalost brskalnik Internet Explorer za ta test ali razgovor ni podprt. Uporabite drug brskalnik.',
        qualityTestNotSupported: 'Na žalost testiranje strojne opreme v brskalniku, ki ga uporabljate, ni podprto. Razgovor lahko nadaljujete brez preskusa kakovosti zvoka in videa ali pa uporabite drug brskalnik.',
      },
      reconnectSuccess: 'Povezava je ponovno vzpostavljena.',
      continue: 'Nadaljujte',
    },

    withdraw: {
      title: 'Vas to delovno mesto ne zanima več?',
      description: 'Odstopite od postopka zaposlovanja.',
      buttonText: 'Odstop od postopka zaposlovanja',
      thankYouTitle: 'Hvala.',
      thankYouText: 'Kadrovski oddelek je bil obveščen, da vas delovno mesto ne zanima več.',
      confirm: 'Ali ste prepričani, da želite odstopiti od postopka zaposlovanja? Po odstopu ne morete več odgovarjati na vprašanja tega ali katerega koli drugega razgovora, povezanega s tem delovnim mestom.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Pošlji',
      continue: 'Nadaljuj',
      supportCenter: 'Recright Help Center',
      thankYou: 'Hvala za vaš video odgovor! V kratkem se vam bomo oglasili!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Hvala za sodelovanje na razgovoru!',
      reopenDescription: 'Če ste intervju zaključili po pomoti, brez skrbi! Intervju lahko znova odprete s klikom na spodnji gumb!',
      reopenButtonText: 'Ponovno odprite intervju',
      description1: 'Odlično, odgovorili ste na vsa vprašanja, ki so bila poslana prejemniku.',
      descriptionsupport: mailto => `V primeru, da ste ta razgovor zaprli po nesreči, prosimo, stopite v stik z našo podporo za stranke ${mailto} in ponovno bomo odprli razgovor.`,
      descriptionfeedback: 'Vaše izkušnje so za nas pomembne! Kakšne so bile vaše izkušnje z odgovarjanjem na video razgovor? Kako bi še izboljšali storitev? Tukaj podajte svoje povratne informacije.',
      feedbackbutton: 'Pošljite nam povratne informacije!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Osebno sporočilo',
    },

    closed: {
      title: 'Razgovor je zaključen, ali pa se je končal',
      description: 'Video razgovor, na katerega ste bili povabljeni, se je končal, ali pa ste zaključili svojo prijavo.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Vaš video razgovor je sedaj shranjen!',
      description: 'Ko želite nadaljevati z video razgovorom, uporabite povezavo, ki ste jo v preteklosti prejeli prek e-pošte. Video odgovori, ki ste jih že posneli, bodo čakali, da se vrnete! Veliko sreče pri iskanju dela!',
      remember: 'Ne pozabite, da morate odgovore poslati zaposlitvenemu agentu, ko zaključite z razgovorom.',
      deleteHistory: 'V primeru, da video razgovor opravljate na javnem računalniku, ne pozabite izbrisati svoje zgodovine brskanja. V tem primeru je vaš video razgovor varen.',
    },
    unpublished: {
      title: 'Razgovor se še ni začel',
      publishTime: publishTime => `Razgovor se začne ob ${publishTime}`,
    },
  },
}
